// @flow
import ChatBox from "./ChatBox";

export default ChatBox;
